import React from "react";

function CommonTableColumn(props) {
    const { kind, children } = props;

    const getColorForStep = (step) => {
        switch (step) {
            case '예약요청':
                return 'black'; // 예약요청
            case '매칭완료':
                return 'green'; // 매칭완료
            case '작업완료':
                return 'blue'; // 작업완료
            case '예약취소':
                return 'red'; // 예약취소
            default:
                return 'black'; // 기본
        }
    };

    const style = kind === 'step' ? { color: getColorForStep(children) } : {};

    return (
        <td className="common-table-column" style={style}>
            {children}
        </td>
    );
}

export default CommonTableColumn;
